const OPENAI_API = 'https://openaitimesheet.azurewebsites.net/'
// const ACS_API = 'https://app-cog-acs-eastus-001.azurewebsites.net/'
const VERTEX_API = 'https://videosummerize.medrecordexchange.com/'
const OPENAI_API_NEW = 'https://ahsgpt.medrecordexchange.com/'
const ACS_API = 'https://ahsgpt.medrecordexchange.com/'
export const openaiEnv = {
    OPENAI_API: OPENAI_API,
    ACS_API: ACS_API,
    VERTEX_API:VERTEX_API,
    OPENAI_API_NEW : OPENAI_API_NEW
}